var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoreKpi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-core-kpi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "core-kpi",
    clipPath: "url(#clip-core-kpi)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -572.737, -169.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(501 318)",
    fill: "#fff3dc",
    stroke: "#ffc551",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.581,
    cy: 28.581,
    r: 28.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.581,
    cy: 28.581,
    r: 26.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "core_kpi",
    "data-name": "core kpi",
    transform: "translate(528.047 343.967)",
    fill: "#ffc551",
    fontSize: 15,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.9,
    y: 0
  }, "CORE"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.173,
    y: 16
  }, "KPI"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreKpi);
export default __webpack_public_path__ + "static/media/core-kpi.82b89bd63cbeee403b3a0344da53fbde.svg";
export { ForwardRef as ReactComponent };